module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table_width"
  }, [_c('Table', {
    staticClass: "border",
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.dataNews
    },
    on: {
      "on-selection-change": _vm.changeProdNumber
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hand_move_wei_hu_cheng_pin"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shoutiandis),
      expression: "shoutiandis"
    }]
  }, [_c('RadioGroup', {
    staticClass: "hand_move_wei_hu_cheng_pin_width",
    attrs: {
      "vertical": ""
    },
    on: {
      "on-change": _vm.changeWidthList
    },
    model: {
      value: (_vm.changeWidth),
      callback: function($$v) {
        _vm.changeWidth = $$v
      },
      expression: "changeWidth"
    }
  }, [_c('Radio', {
    staticClass: "radios",
    attrs: {
      "label": "last"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.language.shengyu))]), _vm._v(" "), _c('span', {
    staticClass: "hand_move_wei_hu_last"
  }, [_vm._v(_vm._s(_vm.lastWidth))]), _vm._v(" "), _c('span', {
    staticClass: "biansitxt"
  }, [_vm._v(_vm._s(_vm.language.shengyudayu204shibixukouchu4mm))])]), _vm._v(" "), _c('Radio', {
    staticClass: "radios",
    attrs: {
      "label": "residue",
      "id": "biansi"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.language.biansi))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handNoveWeiHuChengPinWidth),
      expression: "handNoveWeiHuChengPinWidth"
    }],
    staticClass: "hand_move_wei_hu_last"
  }, [_vm._v(_vm._s(_vm.residueWidth))]), _vm._v(" "), _c('span', {
    staticClass: "biansitxt"
  }, [_vm._v(_vm._s(_vm.language.biansifanweibixuzai3dao40zhijianxiaoyu3zebuketijiao))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "position_hand_move_div"
  }, [_c('span', [_vm._v(_vm._s(_vm.language.jiaohuodi) + "：")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.shengYuArea),
      callback: function($$v) {
        _vm.shengYuArea = $$v
      },
      expression: "shengYuArea"
    }
  }, _vm._l((_vm.placeofDelivery), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }))], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.xinzengshow),
      expression: "xinzengshow"
    }],
    staticClass: "hand_move_wei_hu_cheng_pin_add",
    on: {
      "click": _vm.handMoveWeiHuChengPinAdd
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('p', {
    staticClass: "position_hand_move"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.handNoveWeiHuChengPinWidth),
      expression: "!handNoveWeiHuChengPinWidth"
    }],
    staticClass: "hand_move_wei_hu_last"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.handNoveWeiHuChengPinTrue),
      expression: "handNoveWeiHuChengPinTrue"
    }],
    staticClass: "hand_move_wei_hu_cheng_pin_true",
    on: {
      "click": _vm.handMoveWeiHuChengPinTrue
    }
  }, [_vm._v(_vm._s(_vm.language.baocun))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.handNoveWeiHuChengPinTrue),
      expression: "!handNoveWeiHuChengPinTrue"
    }],
    staticClass: "hand_move_wei_hu_cheng_pin_true btn_black",
    on: {
      "click": _vm.messageInfomation
    }
  }, [_vm._v(_vm._s(_vm.language.baocun))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4484010e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/addDingDanComplate.vue
// module id = 913
// module chunks = 1